module.exports = __webpack_public_path__ + "img/advantage_four.d2563ce0.png";